export interface Category {
  id: number;
  nameIt: string;
  nameEn: string;
  url: string;
}

export const categories: Category[] = [
  {
    id: 1,
    nameIt: 'Scarpe',
    nameEn: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
  },
  {
    id: 2,
    nameIt: 'Felpe/Maglie',
    nameEn: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
  },
  {
    id: 3,
    nameIt: 'T-Shirt',
    nameEn: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
  },
  {
    id: 4,
    nameIt: 'Giacche',
    nameEn: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
  },
  {
    id: 5,
    nameIt: 'Pantaloni/Corti',
    nameEn: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
  },
  {
    id: 6,
    nameIt: 'Copricapi',
    nameEn: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
  },
  {
    id: 7,
    nameIt: 'Completi',
    nameEn: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
  },
  {
    id: 8,
    nameIt: 'Intimo',
    nameEn: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
  },
  {
    id: 9,
    nameIt: 'Maglie Sportive',
    nameEn: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
  },
  {
    id: 10,
    nameIt: 'Accessori',
    nameEn: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
  },
  {
    id: 11,
    nameIt: 'Borse',
    nameEn: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
  },
  {
    id: 12,
    nameIt: 'Cinture',
    nameEn: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
  },
  {
    id: 13,
    nameIt: 'Profumi',
    nameEn: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
  },
  {
    id: 14,
    nameIt: 'Altri Articoli',
    nameEn: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';